import {Pipe, PipeTransform} from '@angular/core';
import {ShipmentStatusFilter} from './shipment-status-filter';

@Pipe({
    name: 'shipmentStatusFilterName',
    standalone: false
})
export class ShipmentStatusFilterNamePipe implements PipeTransform {
  transform(statusFilter: ShipmentStatusFilter): string {
    switch (statusFilter) {
      case ShipmentStatusFilter.NotStarted:
        return 'Ikke påbegynt';
      case ShipmentStatusFilter.Started:
        return 'Påbegynt';
      case ShipmentStatusFilter.Assigned:
        return 'Tildelt';
      case ShipmentStatusFilter.NotAssigned:
        return 'Ikke tildelt';
      case ShipmentStatusFilter.Finished:
        return 'Fullført';
      default:
        return statusFilter;
    }
  }
}
